module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKW-U9hmIqOjjg.9e010966.woff2";